// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings-group{background-color:#555;display:flex;margin-left:5px;border-width:2px;border-radius:5px;color:#fff}.feature_menu{color:#fff;display:flex;justify-content:center;align-items:center}@media screen and (max-width:944px){#settings-group-header{display:none}#responsiveTab{display:flex}}.right-tool-btn .p-button.p-button-icon-only{padding:.5rem 1.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
